import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { h as s } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function l({
  position: o,
  offsetLevel: t,
  indent: i,
  el: n
}) {
  const r = {
    position: "absolute",
    boxSizing: "border-box",
    right: 0
  };
  if (o === "inside")
    r.left = 0, r.top = 0, r.bottom = 0, r.borderRadius = "inherit", r.boxShadow = "inset 0 0 0 2px var(--n-drop-mark-color)";
  else {
    const e = o === "before" ? "top" : "bottom";
    r[e] = 0, r.left = `${n.offsetLeft + 6 - t * i}px`, r.height = "2px", r.backgroundColor = "var(--n-drop-mark-color)", r.transformOrigin = e, r.borderRadius = "1px", r.transform = o === "before" ? "translateY(-4px)" : "translateY(4px)";
  }
  return s("div", {
    style: r
  });
}
function d({
  dropPosition: o,
  node: t
}) {
  return t.isLeaf === !1 || t.children ? !0 : o !== "inside";
}
export {
  d as defaultAllowDrop,
  l as renderDropMark
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/dnd.js
// module id = 979
// module chunks = 67